import { render, staticRenderFns } from "./SelectorChipsFilter.vue?vue&type=template&id=2f4803f0&"
import script from "./SelectorChipsFilter.vue?vue&type=script&lang=js&"
export * from "./SelectorChipsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f4803f0')) {
      api.createRecord('2f4803f0', component.options)
    } else {
      api.reload('2f4803f0', component.options)
    }
    module.hot.accept("./SelectorChipsFilter.vue?vue&type=template&id=2f4803f0&", function () {
      api.rerender('2f4803f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/selector/fragment/SelectorChipsFilter.vue"
export default component.exports